const PRIMARY_MOBILE_PATHS = new Set([
  "/dashboard",
  "/festivals",
  "/riders",
  "/crew",
  "/settings",
  "/my-schedule",
  "/my-shifts",
  "/admin",
  "/design-system",
  "/learn",
]);

function normalizePathname(pathname: string): string {
  if (pathname === "/") return pathname;
  return pathname.replace(/\/+$/, "");
}

/**
 * Return the deterministic parent for routes that need a shell-level Back
 * affordance. Primary destinations keep the menu button instead.
 */
export function mobileBackFallback(pathname: string): string | null {
  const normalized = normalizePathname(pathname);

  if (PRIMARY_MOBILE_PATHS.has(normalized)) return null;
  if (/^\/festivals\/[^/]+(?:\/.*)?$/.test(normalized)) return "/festivals";
  if (/^\/riders\/(?:upload|[^/]+\/review)$/.test(normalized)) return "/riders";
  if (/^\/my-schedule\/[^/]+(?:\/.*)?$/.test(normalized)) return "/my-schedule";
  if (/^\/admin\/.+/.test(normalized)) return "/admin";
  if (/^\/learn\/.+/.test(normalized)) return "/learn";

  return "/dashboard";
}

/**
 * React Router stores an index in history.state. Using that instead of the
 * browser's total history length avoids sending an installed PWA back to an
 * unrelated app or website after a direct launch.
 */
export function hasInAppHistory(state: unknown): boolean {
  if (!state || typeof state !== "object") return false;
  const index = (state as { idx?: unknown }).idx;
  return typeof index === "number" && index > 0;
}
